export default () => [
  {
    id: '1',
    power_type: 'AC',
    power: 22,
    time_to_charge: 303,
    estimated_cost: 'A$ 5,000',
  },
  {
    id: '2',
    power_type: 'DC',
    power: 25,
    time_to_charge: 266,
    estimated_cost: 'A$ 12,000',
  },
  {
    id: '3',
    power_type: 'DC',
    power: 50,
    time_to_charge: 133,
    estimated_cost: 'A$ 35,000',
  },
  {
    id: '4',
    power_type: 'DC',
    power: 120,
    time_to_charge: 63,
    estimated_cost: 'A$ 67,000',
  },
  {
    id: '5',
    power_type: 'DC',
    power: 150,
    time_to_charge: 55,
    estimated_cost: 'A$ 80,000',
  },
]
